import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Agenda from '@/components/Agenda'
import AgeForm from '@/components/AgeForm'
import AgeRelWeek from '@/components/AgeRelWeek'
import Clientes from '@/components/Clientes'
import CliForm from '@/components/CliForm'
import CliRelCob from '@/components/CliRelCob'
import CliRelCobDocs from '@/components/CliRelCobDocs'
import CliRelCobGrupo from '@/components/CliRelCobGrupo'
import CliRelSup from '@/components/CliRelSup'
import Email from '@/components/Email'
import EmailForm from '@/components/EmailForm'
import EmailRel from '@/components/EmailRel'
import EmailRelSend from '@/components/EmailRelSend'
import Ferias from '@/components/Ferias'
import FerRel from '@/components/FerRel'
import Home from '@/components/Home'
import Manuais from '@/components/Manuais'
import ManForm from '@/components/ManForm'
import ManRel from '@/components/ManRel'
import ManRelCat from '@/components/ManRelCat'
import Mensagem from '@/components/Mensagem'
import MensagemForm from '@/components/MensagemForm'
import MensagemRel from '@/components/MensagemRel'
import MensagemSelect from '@/components/MensagemSelect'
import Pacote from '@/components/Pacote'
import PackRel from '@/components/PackRel'
import Tarefas from '@/components/Tarefas'
import TarForm from '@/components/TarForm'
import TarRel from '@/components/TarRel'
import TarRelHistory from '@/components/TarRelHistory'
import Users from '@/components/Users'
import UserRel from '@/components/UserRel'
import UserForm from '@/components/UserForm'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/agenda/:crud/:id',
      name: 'AgendaForm',
      component: Agenda,
      children: [
        {
          path: '',
          component: AgeForm
        }
      ]
    },
    {
      path: '/agenda',
      name: 'Agenda',
      component: Agenda,
      children: [
        {
          path: '',
          component: AgeRelWeek
        }
      ]
    },
    {
      path: '/cliente/:id',
      component: Clientes,
      children: [
        {
          path: '',
          component: CliForm
        }
      ]
    },
    {
      path: '/cliente/:grupo/:id',
      component: Clientes,
      children: [
        {
          path: '',
          component: CliForm
        }
      ]
    },
    {
      path: '/clientes/cob/docs',
      component: Clientes,
      children: [
        {
          path: '',
          component: CliRelCobDocs
        }
      ]
    },
    {
      path: '/clientes/cob/:grupo',
      component: Clientes,
      children: [
        {
          path: '',
          component: CliRelCobGrupo
        }
      ]
    },
    {
      path: '/clientes/cob',
      component: Clientes,
      children: [
        {
          path: '',
          component: CliRelCob
        }
      ]
    },
    {
      path: '/clientes/sup',
      component: Clientes,
      children: [
        {
          path: '',
          component: CliRelSup
        }
      ]
    },
    {
      path: '/email/:crud/:id',
      component: Email,
      children: [
        {
          path: '',
          component: EmailForm
        }
      ]
    },
    {
      path: '/emails/:id',
      component: Email,
      children: [
        {
          path: '',
          component: EmailRelSend
        }
      ]
    },
    {
      path: '/emails',
      component: Email,
      children: [
        {
          path: '',
          component: EmailRel
        }
      ]
    },
    {
      path: '/manual/:crud/:id',
      component: Manuais,
      children: [
        {
          path: '',
          component: ManForm
        }
      ]
    },
    {
      path: '/manuais/:cat',
      component: Manuais,
      children: [
        {
          path: '',
          component: ManRelCat
        }
      ]
    },
    {
      path: '/manuais',
      component: Manuais,
      children: [
        {
          path: '',
          component: ManRel
        }
      ]
    },
    {
      path: '/mensagens/:id',
      component: Mensagem,
      children: [
        {
          path: '',
          component: MensagemSelect
        }
      ]
    },
    {
      path: '/mensagens',
      component: Mensagem,
      children: [
        {
          path: '',
          component: MensagemRel
        }
      ]
    },
    {
      path: '/mensagem/:crud/:id',
      component: Mensagem,
      children: [
        {
          path: '',
          component: MensagemForm
        }
      ]
    },
    {
      path: '/pacotes/:id',
      component: Pacote,
      children: [
        {
          path: '',
          component: PackRel
        }
      ]
    },
    {
      path: '/pacotes',
      component: Pacote,
      children: [
        {
          path: '',
          component: PackRel
        }
      ]
    },
    {
      path: '/tarefa/:crud/:id',
      component: Tarefas,
      children: [
        {
          path: '',
          component: TarForm
        }
      ]
    },
    {
      path: '/tarefas',
      name: 'Tarefas',
      component: Tarefas,
      children: [
        {
          path: '',
          component: TarRel
        }
      ]
    },
    {
      path: '/historico/:id',
      name: 'Historico',
      component: Tarefas,
      children: [
        {
          path: '',
          component: TarRelHistory
        }
      ]
    },
    {
      path: '/historico',
      name: 'Historico',
      component: Tarefas,
      children: [
        {
          path: '',
          component: TarRelHistory
        }
      ]
    },
    {
      path: '/usuarios',
      component: Users,
      children: [
        {
          path: '',
          component: UserRel
        }
      ]
    },
    {
      path: '/usuario/:id',
      component: Users,
      children: [
        {
          path: '',
          component: UserForm
        }
      ]
    },
    {
      path: '/ferias',
      component: Ferias,
      children: [
        {
          path: '',
          component: FerRel
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js